import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { fetchCartItems } from '../../../actions'
import { clearCartItems } from '../../../redux/storeConfig/slices/slice.cart'
import { createCheckoutSessionToken } from '../../../redux/storeConfig/slices/slice.checkoutSessionToken'
import { fetchIntegrations } from '../../../redux/storeConfig/slices/slice.integrations'
import {
  checkoutOrderCleanup,
  setCheckoutLoading,
  setAppliedCoupon,
  setErrors,
  restoreMultiAddressSelectionFromToken
} from '../checkoutFunctions'

/**
 * Custom hook to handle checkout page initialization
 * @param {object} currentLocation - Current store location
 * @param {object} currentUser - Current user object
 * @returns {object} - { isInitializing: boolean }
 */
export const useCheckoutInitialization = (currentLocation, currentUser) => {
  const dispatch = useDispatch()
  const [isInitializing, setIsInitializing] = useState(true)

  useEffect(() => {
    const initialize = async () => {
      try {
        await dispatch(setCheckoutLoading(true))
        await dispatch(clearCartItems())
        await dispatch(checkoutOrderCleanup(currentLocation))
        await dispatch(setAppliedCoupon(''))

        await dispatch(
          setErrors({
            shipping: false,
            contactEmail: !currentUser?.id,
            maxQuantity: false,
            requireApprovalRule: false
          })
        )

        window.scrollTo(0, 0)

        dispatch(fetchIntegrations({ mode: 'shipper_hq_check' }))

        const tokenResult = await dispatch(createCheckoutSessionToken())

        // If token was created/retrieved, try to restore multi-address selections
        if (tokenResult?.token) {
          await dispatch(restoreMultiAddressSelectionFromToken(tokenResult.token))
        }

        await dispatch(fetchCartItems())

        setIsInitializing(false)
      } catch (error) {
        console.error('Initialization failed:', error)
        setIsInitializing(false)
      }
    }

    initialize()

    // Proper cleanup - just reset state, no side effects
    return () => {
      setIsInitializing(true)
    }
  }, [dispatch, currentLocation, currentUser?.id])

  return { isInitializing }
}
